import { format } from 'date-fns'
import dayjs, { Dayjs } from 'dayjs'

export const formattedTime = (value: Dayjs | string | null | number) => {
  return dayjs(value).format('YYYY-MM-DDTHH:mm:ssZ')
}

export const formattedTimeStandart = (value: any) => {
  return dayjs(value)?.format('YYYY-MM-DD')
}

export const formatDateTimePickerValue = (value: Dayjs | string | null | number) => {
  return dayjs(dayjs.unix(Number(value)).format('YYYY-MM-DDTHH:mm'))
}

export const formatTimeStampToDate = (date: Dayjs | string | null | number) => {
  const localDate = Number(date);

  if (!localDate) {
    return null
  }

  return format(new Date( localDate * 1000), 'dd MMM, yyyy HH:mm')
}

export const formatTimeStampToStandartDate = (date: Dayjs | string | null | number) => {
  const localDate = Number(date);

  if (!localDate) {
    return null
  }

  return format(new Date(localDate * 1000), 'dd.MM.yyyy')
}

export const formatTimeStampToDateWithTime = (date: Dayjs | string | null | number) => {
  const localDate = Number(date);

  if (!localDate) {
    return null
  }

  return format(new Date(localDate * 1000), 'dd.MM.yyyy, HH:mm')
}

export const isBeforeGivenDate = (value: any) => {
  const currentDate = dayjs()
  const apiDate = dayjs.unix(value)
  const checkBefore = apiDate.isBefore(currentDate)
  return checkBefore
}
